import React, { useContext, useEffect } from 'react'
import { useLazyQuery, gql, NetworkStatus } from '@apollo/client'
import { omit } from 'lodash'
import CardWidget, { Colors } from '../../../../components/CardWidget'
import CardWidgetSkeleton from '../../../../components/skeletons/CardWidgetSkeleton'
import { DailyMonitoringFiltersContext } from '../../../../context/DailyMonitoringFiltersContext'
import { formatNumber } from '../../../../utils/Helpers'

const GET_DATA = gql`
  query leadCounter($filters: JSON) {
    count(
      index: "pharmacy-global-configuration",
      filters: $filters,
      query: {
        bool: {
          filter: [{
            term: {
              statusName: "Lead"
            }
          }]
        }
      }
    )
  }
`

const PharmaciesOnline = (): JSX.Element => {
  const { filters } = useContext(DailyMonitoringFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_DATA, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: { filters: omit(filters, 'orderTotals') }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <CardWidgetSkeleton />
  if (loading || !data) return <CardWidgetSkeleton />
  if (error) return <p>Error :(</p>

  return (
    <CardWidget title="Farmácias em lead" number={formatNumber(data.count, 0)} color={Colors.blue} />
  )
}

export default PharmaciesOnline
